import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => ({
    table: {
        border: `1px solid ${theme.colors.gray[100]}`,
        borderRadius: 8,
        overflow: 'hidden',
    },
    columnHeader: {
        fontSize: '11px',
        borderRight: `1px solid ${theme.colors.primary.contrastWhite}`,
        color: theme.colors.gray[800],
        '&.clickable': {
            cursor: 'pointer',
        },
    },
    columnSelectorHeader: {
        width: 75,
        cursor: 'pointer',
    },
    columnSelectorLabelContainer: {
        justifyContent: 'center',
    },
    totalsRowLabel: {
        fontWeight: 600,
    },
    totalsRow: {
        '& td': {
            position: 'relative',
        },
        '& td:before': {
            content: '""',
            width: '100%',
            height: '100%',
            backgroundColor: theme.colors.primary.main,
            opacity: 0.1,
            display: 'block',
            top: 0,
            left: 0,
            position: 'absolute',
        },
    },
    totalsRowEmpty: {
        color: theme.colors.gray[500],
    },
    evenRow: { backgroundColor: theme.colors.primary.contrastWhite },
    oddRow: { backgroundColor: theme.colors.gray[0] },
    tableBodyCell: Object.assign(Object.assign({}, theme.typography.body2), { border: 'none' }),
    tooltipLabelContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    noDataMessage: {
        padding: theme.spacing(10, 0),
        textAlign: 'center',
        '& > *': {
            color: theme.colors.text[600],
            fontSize: 24,
            fontWeight: 200,
        },
    },
    sortIcons: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: 2,
        marginLeft: theme.spacing(1),
    },
    sortIcon: {
        width: 0,
        height: 0,
        opacity: 0.2,
        '&.up': {
            borderLeft: '3px solid transparent',
            borderRight: '3px solid transparent',
            borderBottom: `5px solid ${theme.colors.gray[700]}`,
        },
        '&.down': {
            borderLeft: '3px solid transparent',
            borderRight: '3px solid transparent',
            borderTop: `5px solid ${theme.colors.gray[700]}`,
        },
        '&.active': {
            opacity: 1,
        },
    },
}));
//# sourceMappingURL=PaginationTable.styles.js.map